var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-address-edit',{attrs:{"area-list":_vm.areaList,"show-set-default":"","area-columns-placeholder":['请选择', '请选择', '请选择']},on:{"save":_vm.onSave,"delete":_vm.onDelete,"change-default":_vm.onDefault,"change-detail":_vm.onChangeDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }